<shrd-uic-modal
  #contactModal
  [title]="'header.meta.contactUs' | i18next"
  [bodyRef]="modalContentTpl"
  [subHeaderRef]="modalTabsetTpl"
  [footerRef]="modalFooterTpl"
  [centered]="false"
  [fitToContent]="true"
  windowClass="page-frame-contact-modal"
>
  <ng-template #modalTabsetTpl>
    <shrd-pf-ft-contact-header [inModal]="true" [activeTab]="activeTab"></shrd-pf-ft-contact-header>
  </ng-template>
  <ng-template #modalContentTpl>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <shrd-pf-ft-contact-body class="content-box contact-body" [userData]="userData"></shrd-pf-ft-contact-body>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooterTpl>
    <shrd-pf-ft-contact-footer
      class="w-100"
      [inModal]="true"
      [userData]="userData"
      (closeAction)="contactModal.close()"
    ></shrd-pf-ft-contact-footer>
  </ng-template>
</shrd-uic-modal>
